import global$1 from './global.js';
import requireObjectCoercible$1 from './require-object-coercible.js';

var global = global$1;
var requireObjectCoercible = requireObjectCoercible$1;
var Object$1 = global.Object; // `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject

var toObject = function (argument) {
  return Object$1(requireObjectCoercible(argument));
};

export { toObject as default };
